import React from 'react';
import enhance from './enhance';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

export const ModelNavLink = ({
  model,
  seriesByModelId,
  modelUrl,
  arrow,
  seriesString,
  direction,
  right,
}) => {
  return (
    <span className={styles.navLink}>
      <Link to={modelUrl}>
        <div className={styles.modelNav}>
          {!right && <img alt={'arrow'} src={arrow} />}
          <span className={styles.label}>
            {' '}
            {seriesString} {seriesByModelId.name}: {model.description}
          </span>
          {right && <img alt={'arrow'} src={arrow} />}
        </div>
      </Link>
    </span>
  );
};

export default enhance(ModelNavLink);
